import { BillingStore } from "@/Billing/Stores/BillingStore";
import * as LocalOperations from "@/Common/Operations/operations.local";
import { LocalEvent } from "@/Common/Stores/Actions/LocalEvent";
import { BaseOperationHandler } from "@/Common/Stores/Handlers/Local/BaseOperationHandler";

class SalesInboxHandler extends BaseOperationHandler {
    constructor() {
        super();

        this.RegisterOperation(LocalOperations.Billing.Sales_Search_CurrentPageChange, this.ResultsPageChange);
        this.RegisterOperation(LocalOperations.Billing.Sales_SearchSettings_OnResultsPerPageChange, this.ResultsPerPageChange);
        this.RegisterOperation(LocalOperations.Billing.Sales_Refresh_ButtonClick, this.RefreshButtonClick);
        this.RegisterOperation(LocalOperations.Billing.Sales_SearchBoxTextChanged, this.Search_TextChanged);
    }

    private ResultsPageChange(request: LocalEvent, store: BillingStore): void {
        var value = request.Get<number>("Page");
        store.SalesInboxModel = store.SalesInboxModel.set("SelectedPageNumber", value);
        store.BillingAction.LoadSalesData(store.SalesInboxModel);
    }

    private ResultsPerPageChange(request: LocalEvent, store: BillingStore): void {
        store.SalesInboxModel = store.SalesInboxModel
            .set("SelectedPageNumber", 1)
            .set("SelectedPageSizeOption", request.Get<number>("value"));
    }

    private RefreshButtonClick(request: LocalEvent, store: BillingStore): void {
        store.SalesInboxModel = store.SalesInboxModel.set("SelectedPageNumber", 1);
        store.BillingAction.LoadSalesData(store.SalesInboxModel);
    }

    private Search_TextChanged(request: LocalEvent, store: BillingStore): void {
        store.SalesInboxModel = store.SalesInboxModel
            .set("SelectedPageNumber", 1)
            .set("GlobalSalesSearchText", request.Get<string>("value"));
        store.BillingAction.LoadSalesData(store.SalesInboxModel);
    }
}

export { SalesInboxHandler };
